import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/charter/${Id}`);
  },
  getMains() {
    return API.apiClient.get(`/charter/`);
  },
  postMain(payload) {
    return API.apiClient.post(`/charter/`, payload);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/charter/${Id}`, payload);
  },
  deleteMain(Id) {
    return API.apiClient.delete(`/charter/${Id}`);
  },
};
